/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { generatePassageWithAI, getPassageDetail } from '@apis/questiongenerationservice';
import { useQuery, useMutation } from 'react-query';
import { error as showError } from '@utils/toast';
import { Passage } from './types';

export const useGeneratePassage = () =>
  useMutation(
    async (prompt: string) => {
      const response = await generatePassageWithAI(prompt);
      return response.data;
    },
    {
      mutationKey: ['generatePassageWithAI'],
      retry: 1,
      onError: (err: any) => {
        const errorMessage =
          err?.message || 'Failed to generate passage. Please try again.';
        showError(errorMessage);
      },
    },
  );

export const useGetPassage = (passage: string | Passage | null) => {
  const isObject = typeof passage === 'object';
  const reference = isObject ? passage?.reference : passage;
  const queryResponse = useQuery(
    ['useGetFeatureByIds', reference],
    async () => {
      if (!reference) {
        return null;
      }

      if (isObject) {
        return passage;
      }
      const { response } = await getPassageDetail(passage);
      return response?.data ?? null;
    },
    {
      suspense: false,
      staleTime: 60 * 60 * 24,
      refetchOnMount: false,
    },
  );

  return {
    data: queryResponse?.data,
    isLoading: queryResponse.isLoading,
  };
};
